import classNames from 'classnames';
import PropTypes from 'prop-types';

const HomeWiFiIcon = ({ className, width = '24' }) => {
  return (
    <svg
      className={classNames('home-wi-fi-icon', className)}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17.1139 13.75C15.3846 13.75 13.7944 14.3895 12.4883 15.452L13.7504 17.0035C14.742 16.1968 15.8958 15.75 17.1139 15.75C18.3358 15.75 19.4931 16.1996 20.4868 17.0111L21.7519 15.4621C20.4435 14.3935 18.8487 13.75 17.1139 13.75Z'
        fill='currentColor'
      />
      <path
        d='M17.1139 17.1107C16.134 17.1107 15.2165 17.3984 14.4172 17.894L15.4711 19.5937C15.9791 19.2788 16.535 19.1107 17.1139 19.1107C17.6957 19.1107 18.2544 19.2804 18.7645 19.5985L19.8227 17.9015C19.0207 17.4013 18.0988 17.1107 17.1139 17.1107Z'
        fill='currentColor'
      />
      <path
        d='M17.1211 20.75C16.5688 20.75 16.1211 21.1977 16.1211 21.75C16.1211 22.3023 16.5688 22.75 17.1211 22.75H17.1274C17.6797 22.75 18.1274 22.3023 18.1274 21.75C18.1274 21.1977 17.6797 20.75 17.1274 20.75H17.1211Z'
        fill='currentColor'
      />
      <path
        d='M11.9536 1.40418C11.6846 1.19857 11.3113 1.19861 11.0424 1.40428L2.54437 7.90428C2.32238 8.07407 2.21322 8.35321 2.26112 8.62855L4.26178 20.1285C4.32427 20.4878 4.63606 20.75 5.00068 20.75H14.379L10.3789 15.2351L11.5425 14.2885C13.0843 13.0341 15.0018 12.25 17.1147 12.25C18.1354 12.25 19.1105 12.433 20.0196 12.7635L20.7389 8.62855C20.7868 8.35315 20.6776 8.07396 20.4555 7.90418L11.9536 1.40418Z'
        fill='currentColor'
      />
    </svg>
  );
};

HomeWiFiIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default HomeWiFiIcon;
